<template>
    <div class="d-flex align-items-center justify-content-between border-top totalR pt-4 mt-4" v-if="getList.totalRecords > 0">
        <p class="m-0">
            Total Records <span class="totalRecords">{{getList.totalRecords}}</span>
        </p> 
        <paginate
            :page-count="Math.ceil(getList.totalRecords/pageLimit_parent)"
            :page-range="3"
            :click-handler="fetchData"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'">
        </paginate>
    </div>
</template>
<script>
    export default {
        name: 'PAGINATION',
        data () {
            return { }
        },
        props:['getList','pageLimit_parent' ],
        methods:{
            fetchData(pageNum){
                this.$parent.page = pageNum
                this.$parent.listing()
            }
        }
    }
</script>
<style type="text/css">
.pagination {
    float: right;
}
.pagination li{
    margin: 0;
}
.pagination li a {
    color: var(--fadetext);
    display: inline-block;
    background: var(--lightgraycolor);
    border-radius: 0;
    min-width: 40px;
    height: 35px;
    text-align: center;
    line-height: 34px;
    font-size: 18px;
    font-weight: normal;
    padding: 0 15px;
    border: 1px solid var(--bordercolor);
    border-right: 0;
    font-size: 14px;
}
.pagination li:last-child {
    margin: 0;
    border-right: 1px solid var(--bordercolor);
}
.pagination li.active a {
    background: var(--green);
    color: var(--white);
    display: block;
    border-color: var(--green);
}
</style>


// WEBPACK FOOTER //
// src/components/fxView/shared/pagination.vue